import { useContext, useEffect } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';
import ReviewDetail from '../components/Review/ReviewDetail';

function ReviewDetailPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <ReviewDetail />;
}

export default ReviewDetailPage;
